import { render, staticRenderFns } from "./MessageTemplate.vue?vue&type=template&id=4f69f5aa&scoped=true&"
import script from "./MessageTemplate.vue?vue&type=script&lang=ts&"
export * from "./MessageTemplate.vue?vue&type=script&lang=ts&"
import style0 from "./MessageTemplate.vue?vue&type=style&index=0&id=4f69f5aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f69f5aa",
  null
  
)

export default component.exports